/**
 * This module is utilized for formatting the languages returned from Domuso's backend APIs.
 */
import React from "react";
import { Linking } from "react-native";

import reactStringReplace from "react-string-replace";

import { Text } from "../components";

/**
 * This function format the message that needs to add the `contact support` link which
 * directs the user to their Email client to contact Domuso.
 *
 * @param stringMessage: string message to be formatted if needed.
 * @return JSX.Element
 */
export const templateAddSupportLink = (stringMessage: string): React.ReactNodeArray => {
  // Format message string.
  let formattedString = reactStringReplace(
    stringMessage,
    "<<LINK:CONTACT_SUPPORT>>",
    (match, i) => {
      return (
        <Text
          style={{ textDecorationLine: "underline" }}
          onPress={() => Linking.openURL("mailto:support@domuso.com?subject=Add CC Issue")}>
          contact support
        </Text>
      );
    }
  );
  return formattedString;
}